import { render } from "./Tanda.vue?vue&type=template&id=cc4adc22"
import script from "./Tanda.vue?vue&type=script&lang=js"
export * from "./Tanda.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__